"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_2 = require("react");
const react_router_dom_1 = require("react-router-dom");
const passage_details_1 = require("../../network/passage-details");
const use_lazy_promise_1 = require("../../hook/use-lazy-promise");
const fetch_result_renderer_1 = require("../../component/fetch-result-renderer");
const passage_details_container_1 = require("./passage-details-container");
const passage_meta_1 = require("../../model/passage-meta");
const log_view_layout_1 = require("../../component/log-view-layout");
const log_1 = require("../../model/log");
exports.DetailPage = (0, react_2.memo)(() => {
    const { id } = (0, react_router_dom_1.useParams)();
    const [searchParams, setSearchParams] = (0, react_router_dom_1.useSearchParams)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { result, status, error, executeWithVerify } = (0, use_lazy_promise_1.useLazyPromise)(passage_details_1.getPassageDetailsById);
    const mode = (0, react_1.useMemo)(() => {
        const modeParam = Number(searchParams.get("mode"));
        if (modeParam === passage_meta_1.PassageLearningMode.LISTEN) {
            return passage_meta_1.PassageLearningMode.LISTEN;
        }
        else if (modeParam === passage_meta_1.PassageLearningMode.READ) {
            return passage_meta_1.PassageLearningMode.READ;
        }
        return passage_meta_1.PassageLearningMode.LISTEN;
    }, [searchParams]);
    (0, react_1.useEffect)(() => {
        executeWithVerify(() => {
            if (!id) {
                throw new Error("Cannot find passage");
            }
            return [id];
        });
    }, [executeWithVerify, id]);
    const onQuiz = (0, react_1.useCallback)(() => {
        if (id) {
            navigate(`/quiz/${id}`);
        }
    }, [id, navigate]);
    const onRead = (0, react_1.useCallback)(() => {
        setSearchParams({
            mode: passage_meta_1.PassageLearningMode.READ.toString(),
        });
    }, [setSearchParams]);
    return ((0, jsx_runtime_1.jsx)(log_view_layout_1.LogViewLayout, { eventName: log_1.LogEventViewName.PassageDetailPage, children: (0, jsx_runtime_1.jsx)(fetch_result_renderer_1.FetchResultRenderer, { result: result, status: status, errorMessages: error === null || error === void 0 ? void 0 : error.message, sx: {
                flex: 1,
            }, children: (data) => id && ((0, jsx_runtime_1.jsx)(passage_details_container_1.PassageDetailsContainer, { mode: mode, details: data, onQuiz: onQuiz, onRead: onRead })) }) }));
});
exports.DetailPage.displayName = "DetailPage";
exports.default = exports.DetailPage;
